<template>
  <flex-grid class="GalleryGrid">

    <flex-grid-cell class="GalleryGrid-item"
      :size="cellSize"
      v-for="(smugmugId, index) in images"
      :key="index">

      <div class="GalleryGrid-ratioContainer"
        v-if="ratio"
        :style="ratioContainerStyle">

        <div class="GalleryGrid-ratioContent">

          <crop>

            <image-component
              :smugmug="smugmugId"
              :load="readyToLoad"
              @click.native="openViewer(index)"
              fit="contain"
              zoom />

          </crop>

        </div>

      </div>

      <image-component
        v-if="!ratio"
        :smugmug="smugmugId"
        :load="readyToLoad"
        @click.native="openViewer(index)"
        zoom />

    </flex-grid-cell>

  </flex-grid>
</template>

<script>
export default {
  name: 'GalleryGrid',

  props: {
    images: {
      type: Array,
      required: true
    },
    cellSize: {
      type: String,
      default: '1of4'
    },
    ratio: {
      type: Array
    },
    breadcrumbs: {
      type: Array
    }
  },

  data () {
    return {
      /**
       * TODO:
       * - Set to 'false' to prevent loading until we're ready.
       * - This was causing images to never load in production for some reason,
       *   and may not be necessary now that we're using lazysizes.
       */
      readyToLoad: false
    }
  },

  computed: {
    /**
     * Styles for the ratio container
     * @return {Object}
     */
    ratioContainerStyle () {
      const ratio = this.ratio[1] / this.ratio[0] * 100
      return {
        'padding-top': `${ratio}%`
      }
    }
  },

  mounted () {
    this.$nextTick(this.init)
  },

  methods: {
    /**
     * Initialize
     */
    init () {
      // If we're not permalinking to an image, we're ready to load images now
      if (!this.$route.hash) {
        this.readyToLoad = true
        return
      }

      const id = this.$route.hash.replace('#', '')
      let initialIndex = false

      this.images.forEach((image, index) => {
        if (id !== image) return
        initialIndex = index
      })

      if (initialIndex === false) return

      this.$nextTick(() => {
        this.openViewer(initialIndex, false)

        // Put off loading grid images for a second
        setTimeout(() => {
          this.readyToLoad = true
        }, 1000)
      })
    },

    /**
     * Open the image viewer
     * @param  {Integer} index
     * @param {Boolean} transition whether to use a transition to open
     */
    openViewer (index, transition) {
      this.$store.dispatch('viewer/open', {
        items: this.images,
        index: index,
        breadcrumbs: this.breadcrumbs
      })
    }
  }
}
</script>

<style>
@import 'properties';

.GalleryGrid {
  margin: 0 calc(-1 * var(--unit-025));
}

.GalleryGrid-item {
  padding: var(--unit-025);
}

.GalleryGrid-ratioContainer {
  position: relative;
}

.GalleryGrid-ratioContent {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.GalleryGrid-item .ImageComponent {
  background-color: var(--c-black);
}

.GalleryGrid-item:hover {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// GalleryGrid.vue?cf4b3280